<div class="theme-toggle-row" *ngIf="isLightThemeAvailable">
  <label class="theme-option" [class.active]="isDark" [class.disabled]="isDisabled"
    (click)="setTheme('dark-theme')" (keydown.enter)="setTheme('dark-theme')"
    tabindex="0" role="radio" [attr.aria-checked]="isDark" aria-label="Dark mode">
    <span class="radio-circle"></span>
    <span class="theme-icon" cygovSvgIcon [svgName]="'dark-mode'"></span>
    <span class="theme-label">Dark</span>
  </label>
  <label class="theme-option" [class.active]="isLight" [class.disabled]="isDisabled"
    (click)="setTheme('light-theme')" (keydown.enter)="setTheme('light-theme')"
    tabindex="0" role="radio" [attr.aria-checked]="isLight" aria-label="Light mode">
    <span class="radio-circle"></span>
    <span class="theme-icon" cygovSvgIcon [svgName]="'light-mode'"></span>
    <span class="theme-label">Light</span>
  </label>
</div>
